import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { ReactNode } from 'react';
import { Alert, CloseButton } from 'react-bootstrap';
import type { AlertProps } from 'react-bootstrap';
import classNames from 'classnames';

type IconAlertVariant = 'success' | 'info' | 'warning' | 'danger';

interface IconAlertProps extends AlertProps {
  dismissible?: boolean;
  children?: ReactNode;
  className?: string;
  onClose?: () => void;
  customIcon?: IconProp;
  iconClasses?: string;
}

const IconAlert = ({
  variant,
  dismissible,
  children,
  className,
  onClose,
  customIcon,
  iconClasses = 'fs-2',
  ...rest
}: IconAlertProps) => {
  const icon: Record<IconAlertVariant, IconProp> = {
    success: 'check-circle',
    info: 'info-circle',
    warning: 'exclamation-circle',
    danger: 'times-circle'
  };

  const iconKey = (variant ?? 'info') as IconAlertVariant;
  const resolvedIcon = customIcon ?? icon[iconKey] ?? icon.info;

  return (
    <Alert
      variant={variant}
      className={classNames(className, 'd-flex align-items-center fs--1')}
      {...rest}
    >
      <div
        className={`bg-${variant} d-flex flex-center me-3 rounded-circle shadow-sm border-0`}
        style={{ height: '2.0rem', width: '2.0rem' }}
      >
        <FontAwesomeIcon icon={resolvedIcon} className={` ${iconClasses} text-white`} />
      </div>
      <div className="flex-1">{children}</div>
      {dismissible && <CloseButton onClick={onClose} />}
    </Alert>
  );
};

export default IconAlert;
